<template>
  <div class="page page-full clients-page">
    <template v-if="isClientSelected">
      <div class="page-header with-actions">
        <h1>Tags</h1>
        <div class="actions">
          <b-btn @click="createTag" variant="success">Create New Tag</b-btn>
        </div>
      </div>

      <dt-datatable ref="tagList"
                    :id="tableId"
                    url="/tag/tag-list"
                    :columns="columns"
                    :dt-options="dtOptions"
                    :params="dtParams">

        <template #actions="{ data }">
          <div class="td-links-wrap">
            <a class="btn btn-link pl-0 text-success" @click="editTag(data.id)">Edit</a>
            <a class="btn btn-link text-danger" @click="showModalDelete(data.id)">Delete</a>
          </div>
        </template>
      </dt-datatable>

      <tag-create-edit-modal ref="tagCreateEditModal"
                             @success="tagSaved"
                             :clientId="clientId"
                             :type="TagType.Employer" />

      <b-modal ref="modalDelete"
               cancel-variant="outline-secondary"
               ok-variant="success"
               @ok="deleteTag"
               title="Confirm">
        Are you sure you want to delete this tag? This cannot be undone!
      </b-modal>
    </template>
    <client-select-modal ref="clientSelectModal"
                         path="tags"
                         label="Select client"
                         :show-back-button="false"
                         replace />
  </div>
</template>

<script>
  import { defaults } from "vue-datatables.net";

  import tagCreateEditModal from "@/components/common/modals/tag-create-edit-modal";
  import clientSelectModal from "@/components/common/modals/client-select-modal";

  import { createNamespacedHelpers } from 'vuex';
  const { mapActions } = createNamespacedHelpers('tag');

  import TagType from 'enums/tag-type';

  export default {
    name: 'TagList',
    components: {
      tagCreateEditModal,
      clientSelectModal
    },

    data() {
      return {
        tableId: `tag-list-id-${this.$auth.id}`,
        dtOptions: {
          language: {
            ...defaults.language,
            emptyTable: "You have no tags to manage."
          }
        },
        dtParams: {
          clientId: null
        },

        clientId: null,
        isClientSelected: null,

        tagToDeleteId: null,

        TagType
      }
    },

    computed: {
      columns() {
        let columns = [
          { name: "Id", title: "Tag ID", render: (data) => "#" + data },
          { name: "Name" },
          { name: "Type" },
          { name: "Client" },
          { name: "Actions", title: "Actions", data: false }
        ];

        return columns;
      },

      isClientAdmin() {
        return this.$auth.isInRole("ClientAdmin");
      },

      isAdmin() {
        return this.$auth.isInRole("Admin");
      }
    },

    mounted() {
      this.setIsClientSelected(this.$route.query.id);
    },

    watch: {
      '$route': {
        handler(route) {
          if (route.query.id) {
            this.setIsClientSelected(route.query.id);
          }
          else if (this.isClientAdmin) {
            this.clientId = null;
            this.$refs.clientSelectModal.show();
            this.redrawTable();
          }
        },
        deep: true
      }
    },

    methods: {
      ...mapActions(['delete']),

      setIsClientSelected(clientId) {
        this.clientId = parseInt(clientId);

        if (this.isClientAdmin && !this.clientId) {
          this.isClientSelected = false;

          this.$refs.clientSelectModal.show();
        }
        else if (this.isClientAdmin && this.clientId) {
          this.dtParams.clientId = this.clientId;
          this.isClientSelected = true;
          this.redrawTable();
        }
        else if (this.isAdmin) {
          this.isClientSelected = true;
        }
      },

      showModalDelete(id) {
        this.tagToDeleteId = id;
        this.$refs.modalDelete.show();
      },

      async deleteTag() {
        await this.delete(this.tagToDeleteId);
        this.$root.successToast("Tag deleted!");
        this.redrawTable();
      },

      editTag(id) {
        this.$refs.tagCreateEditModal.show(id);
      },

      createTag() {
        this.$refs.tagCreateEditModal.show();
      },

      tagSaved() {
        this.redrawTable();
        this.$root.successToast('Tag saved!');
      },

      redrawTable() {
        if (this.$refs.tagList) {
          this.$refs.tagList.draw(false);
        }
      },
    }
  }
</script>